import {SectionQuoteBase} from '~/components/SectionQuoteBase';
import {Trans} from '~/components/Trans';
import {ImageType} from '~/features/shared';

export function SectionQuote({
  className,
  image,
}: {
  className?: string;
  image?: ImageType;
}) {
  return (
    <SectionQuoteBase
      img={image?.image}
      title={<Trans i18nKey="pages:servicios:quote.title" />}
      callToActionText={<Trans i18nKey="pages:servicios:quote.action.title" />}
      className={className}
      linkTo="?cotiza-tu-servicio=true"
    />
  );
}
